import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-star-rating',
    template: `
    <div [formGroup]="form" class="form-group">
      <div class="star-rating">
        <span
          *ngFor="let star of stars; let i = index"
          (click)="rate(i + 1)"
          [ngClass]="{'filled': i < value}"
          class="star"
        >
          <i class="fa fa-star"></i>
        </span>
      </div>
      <input
        type="hidden"
        [formControlName]="field.name"
        [id]="field.name"
        [name]="field.name"
        [attr.disabled]="field.disabled"
      >
    </div>
  `,
    styles: [`
  .form-group {
    text-align: center;
    margin-bottom: 0px;
  }
    .star-rating {
      font-size: 24px;
      color: #e4e5e9;
      display: flex;
      justify-content: space-evenly;
    }
    .star {
      cursor: pointer;
      display: inline-block;
      transition: color 0.2s ease;
    }
    .star.filled {
      color: #ffc107;
    }
    .star:hover {
      transform: scale(1.1);
    }
  `],
    standalone: false
})
export class StarRatingComponent {
  @Input() field: any = {};
  @Input() form!: UntypedFormGroup;

  stars = [1, 2, 3, 4, 5];
  hoverRating = 0;
  constructor(
  ) {

  }
  get value(): number {
    return this.form.get(this.field.name)?.value || 0;
  }

  get isValid(): boolean {
    return this.form.controls[this.field.name].valid;
  }

  get isDirty(): boolean {
    return this.form.controls[this.field.name].dirty;
  }

  get isTouched(): boolean {
    return this.form.controls[this.field.name].touched;
  }

  rate(value: number) {
    this.form.controls[this.field.name].setValue(value)
  }
}